import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@design-system';
import { MailCheck } from 'lucide-react';

interface EdjPdfEmailSentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  advisorEmail?: string;
}

export function EdjPdfEmailSentDialog({
  open,
  onOpenChange,
  advisorEmail,
}: EdjPdfEmailSentDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="bg-primary/10 text-primary mx-auto mb-2 flex size-12 items-center justify-center rounded-full">
            <MailCheck
              className="size-6"
              aria-hidden
            />
          </div>
          <DialogTitle className="text-center">Your PDF is on its way</DialogTitle>
          <DialogDescription className="text-center">
            We've generated your report and sent it
            {advisorEmail ? (
              <>
                {' '}to <span className="text-foreground font-medium">{advisorEmail}</span>
              </>
            ) : (
              ' to your email'
            )}
            . It can take up to{' '}
            <span className="text-foreground font-medium">5-10 minutes</span> to arrive in your
            inbox. Please check your inbox (and your spam/junk folder if needed).
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
